import React from "react";
import { Building2, Zap, CircuitBoard, Wallet } from "lucide-react";

const FILIALES = [
  {
    key: "kidh",
    name: "KIDH",
    sector: "Immobilier",
    icon: Building2,
    desc: "Développement immobilier résidentiel et commercial haut de gamme.",
    highlight: false,
    badge: null,
  },
  {
    key: "kip",
    name: "KIP ENERGY",
    sector: "Énergie & Mobilité",
    icon: Zap,
    desc: "Distribution de carburant et infrastructures pétrolières nouvelle génération.",
    highlight: true,
    badge: "Filiale actuelle",
  },
  {
    key: "ekiptech",
    name: "EKIPTECH",
    sector: "Technologies",
    icon: CircuitBoard,
    desc: "Solutions digitales et innovation technologique pour l'écosystème EKIP.",
    highlight: false,
    badge: null,
  },
  {
    key: "kipay",
    name: "KIPAY",
    sector: "Paiement",
    icon: Wallet,
    desc: "Solutions de paiement mobile intégrées à l'écosystème du groupe.",
    highlight: false,
    badge: "En développement",
  },
];

export default function Groupe() {
  return (
    <section
      id="groupe"
      data-testid="groupe-section"
      className="bg-[#F5F6F8] py-24 sm:py-28"
    >
      <div className="kip-container">
        <div className="max-w-3xl mb-14 reveal">
          <span className="kip-overline">L'écosystème</span>
          <span className="kip-accent-bar mt-4" />
          <h2 className="font-display font-black text-[#1A2744] text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
            EKIP Holding Company —{" "}
            <span className="text-[#E85D26]">Ensemble, Vivons Mieux.</span>
          </h2>
          <p className="mt-5 text-[#334155] text-lg leading-relaxed">
            KIP Energy s'inscrit dans un écosystème intégré porté par EKIP
            Holding Company. Immobilier, énergie, technologie, paiement — quatre
            filiales complémentaires pour transformer durablement le quotidien
            des Ivoiriens.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {FILIALES.map((f, i) => (
            <article
              key={f.key}
              data-testid={`filiale-card-${f.key}`}
              className={`relative p-8 transition-all duration-300 border reveal ${
                f.highlight
                  ? "bg-[#1A2744] text-white border-[#E85D26] shadow-lg scale-[1.02]"
                  : "bg-white border-gray-100 hover:-translate-y-1 hover:shadow-lg"
              }`}
            >
              {f.badge && (
                <span
                  className={`absolute top-4 right-4 text-[10px] font-bold uppercase tracking-[0.14em] px-2 py-1 ${
                    f.highlight
                      ? "bg-[#E85D26] text-white"
                      : "bg-[#F5F6F8] text-[#64748B]"
                  }`}
                >
                  {f.badge}
                </span>
              )}
              <div
                className={`w-12 h-12 flex items-center justify-center mb-5 ${
                  f.highlight ? "bg-[#E85D26]" : "bg-[#E85D26]/10"
                }`}
              >
                <f.icon
                  size={24}
                  strokeWidth={1.8}
                  className={f.highlight ? "text-white" : "text-[#E85D26]"}
                />
              </div>
              <h3
                className={`font-display font-black text-2xl tracking-tight ${
                  f.highlight ? "text-white" : "text-[#1A2744]"
                }`}
              >
                {f.name}
              </h3>
              <div
                className={`text-xs uppercase tracking-[0.2em] mt-1 mb-4 font-bold ${
                  f.highlight ? "text-[#E85D26]" : "text-[#E85D26]"
                }`}
              >
                {f.sector}
              </div>
              <p
                className={`text-sm leading-relaxed ${
                  f.highlight ? "text-white/80" : "text-[#334155]"
                }`}
              >
                {f.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
